import {
	SET_DUPLICATE_PAYEE_SUBMITTED,
	REMOVE_DUPLICATE_PAYEE_SUBMITTED,
	SET_ACCOUNT_ERROR,
	UNSET_ACCOUNT_ERROR,
	SET_TEMPLATE_ERROR,
	UNSET_TEMPLATE_ERROR,
	SET_ACCOUNT_NAME_SERVICES_ERROR,
	UNSET_ACCOUNT_NAME_SERVICES_ERROR,
} from '../payees/actions';

const initialState = {
	callsInProgress: [],
};

const getRootType = (type) => type.substring(0, type.lastIndexOf('_'));

const ignoreList = ['UPDATE_OUTCOME_ACK', 'UPDATE_ADDITIONAL_PAYMENT_GUIDANCE'];

const api = (state = initialState, action) => {
	if (action.type) {
		const root = getRootType(action.type);

		if (action.type === SET_DUPLICATE_PAYEE_SUBMITTED) {
			return { ...state, duplicatePayeeSubmitted: true };
		} else if (action.type === REMOVE_DUPLICATE_PAYEE_SUBMITTED) {
			return { ...state, duplicatePayeeSubmitted: false };
		} else if (action.type === SET_ACCOUNT_ERROR) {
			return { ...state, accountError: action.payload };
		} else if (action.type === UNSET_ACCOUNT_ERROR) {
			return { ...state, accountError: null };
		} else if (action.type === SET_TEMPLATE_ERROR) {
			return { ...state, templateError: action.payload };
		} else if (action.type === UNSET_TEMPLATE_ERROR) {
			return { ...state, templateError: null };
		} else if (action.type === SET_ACCOUNT_NAME_SERVICES_ERROR) {
			return { ...state, accountNameServicesError: true };
		} else if (action.type === UNSET_ACCOUNT_NAME_SERVICES_ERROR) {
			return { ...state, accountNameServicesError: null };
		}
		if (!ignoreList.includes(root)) {
			if (action.type.includes('REQUEST')) {
				return { ...state, callsInProgress: state.callsInProgress.concat(root) };
			}

			if (action.type.includes('FAILURE') || action.type.includes('SUCCESS')) {
				return { ...state, callsInProgress: state.callsInProgress.filter((type) => type !== root) };
			}
		}
	}

	return state;
};

export default api;
